import React, { useState } from "react";
import "./TicketPanel.css";

const Comment = ({time, comment, employeeId }) => {
  const overallEmployeeDetails = JSON.parse(localStorage.getItem('employeeAvatars') || '{}');
  const commentedEmployee = overallEmployeeDetails[employeeId];

  const generateAvatarDataUri = (initials, bgColor) => {
    const svg = `
      <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="${bgColor}" />
        <text x="50%" y="55%" text-anchor="middle" fill="#fff" font-size="40" font-family="Arial" dy=".3em">${initials}</text>
      </svg>
    `;
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
  };

  const avatar = generateAvatarDataUri(commentedEmployee['initials'], commentedEmployee['color'])

  return (
    (comment.is_parent_comment === true) ? (
      <div className="comment-container" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
      <img
        src={avatar}
        alt={commentedEmployee['name']}
        className="avatar"
        style={{ width: 25, height: 25, borderRadius: '50%', marginRight: 12 }}
      />
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <span style={{ fontWeight: 600, marginRight: 8 }}>{commentedEmployee['name']}</span>
          <span style={{ fontSize: 12, color: '#aaa' }}>{time}</span>
        </div>
        <div className="comments" dangerouslySetInnerHTML={{ __html: comment.comments }} />
      </div>
    </div>
    ) : (
      <div className="comment-container" style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px', marginLeft : '35px' }}>
      <img
        src={avatar}
        alt={commentedEmployee['name']}
        className="avatar"
        style={{ width: 25, height: 25, borderRadius: '50%', marginRight: 12 }}
      />
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <span style={{ fontWeight: 600, marginRight: 8 }}>{commentedEmployee['name']}</span>
          <span style={{ fontSize: 12, color: '#aaa' }}>{time}</span>
        </div>
        <div className="comments" dangerouslySetInnerHTML={{ __html: comment.comments }} />
      </div>
    </div>
    )
  );
};

export default Comment; 